import React, { useEffect } from 'react'
import Text from 'antd/es/typography/Text'
import { Select } from 'antd'
import useQueryParam from '../../../../../hooks/useQueryParam'
import { GROUP_BY_PARAM } from '../../../../../constants/query-params'
import useQueryParamSetter from '../../../../../hooks/useQueryParamSetter'
import {
    DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_ALL_QUESTIONS_PAGE,
    DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_QUESTION_PAGE,
    getSubmissionGroupByName,
    SubmissionGroupByTypes,
} from '../../../../../constants/groups-by-types'
import { useParams } from 'react-router'
import LocalStorageService from '../../../../../services/local-storage.service'

//change the group by value to 'reviewStatus' when questionIdParam became 'all'
const useQuestionIdEffect = (questionIdParam, groupParam, setQueryParam) => {
    useEffect(() => {
        if (questionIdParam === 'all' && groupParam !== SubmissionGroupByTypes.REVIEW_STATUS) {
            setQueryParam({ [GROUP_BY_PARAM]: DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_ALL_QUESTIONS_PAGE })
        } else if (questionIdParam !== 'all' && groupParam !== SubmissionGroupByTypes.CATEGORY) {
            const groupByTypeForQuestionPage = LocalStorageService.getGroupByTypeForQuestionPage()
            setQueryParam({
                [GROUP_BY_PARAM]: groupByTypeForQuestionPage || DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_QUESTION_PAGE,
            })
        }
    }, [questionIdParam])
}

const GroupBySelect = () => {
    const { layerId: questionIdParam } = useParams()
    const groupParam =
        useQueryParam(GROUP_BY_PARAM) ||
        (questionIdParam === 'all'
            ? DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_ALL_QUESTIONS_PAGE
            : DEFAULT_SUBMISSION_GROUP_BY_TYPE_FOR_QUESTION_PAGE)
    const setQueryParam = useQueryParamSetter()

    useQuestionIdEffect(questionIdParam, groupParam, setQueryParam)

    const groupingOptions = [
        {
            label: getSubmissionGroupByName(SubmissionGroupByTypes.REVIEW_STATUS),
            value: SubmissionGroupByTypes.REVIEW_STATUS,
        },
    ]

    if (questionIdParam !== 'all')
        groupingOptions.push({
            label: getSubmissionGroupByName(SubmissionGroupByTypes.CATEGORY),
            value: SubmissionGroupByTypes.CATEGORY,
        })

    const handleGroupByChange = value => {
        setQueryParam({ [GROUP_BY_PARAM]: value })
        if (questionIdParam !== 'all') LocalStorageService.setGroupByTypeForQuestionPage(value)
    }

    return (
        <label className='d-flex-column'>
            <Text className='mb-4' type='secondary'>
                Group by
            </Text>
            <Select
                value={groupParam}
                style={{ minWidth: 80 }}
                popupMatchSelectWidth={false}
                onChange={handleGroupByChange}
                options={groupingOptions}
                getPopupContainer={triggerNode => triggerNode.parentNode}
                showSearch
                optionFilterProp='label'
            />
        </label>
    )
}

export default GroupBySelect
